import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/axelerate-logo-purple.svg'
import _imports_1 from '@/assets/icons/checkmark-white.svg'
import _imports_2 from '@/assets/icons/chevron-forward-white.svg'
import _imports_3 from '@/assets/ilustration-forgot.svg'


const _hoisted_1 = { class: "bg-background min-h-screen" }
const _hoisted_2 = { class: "flex justify-center items-center min-h-screen" }
const _hoisted_3 = { class: "flex flex-col bg-white shadow rounded-2xl w-1/2 xl:w-1/3 p-14" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-2/5"
}, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "flex-col mt-8"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center w-16 h-16 rounded-full bg-green-500" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "w-8 h-8"
  })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-semibold" }, " Your email address has been confirmed ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row justify-center" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Let's start"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "ml-4"
  })
], -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 2,
  class: "flex flex-col mt-8"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "w-1/2"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col mt-8" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-semibold" }, "No token found")
], -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_Spinner, { key: 0 }))
          : (!_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _hoisted_7,
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/login'))),
                  class: "bg-primary rounded-full px-6 py-4 text-white w-full mt-8"
                }, _hoisted_9)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13))
      ])
    ])
  ]))
}